import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';

// Gate for /app/* — redirects to /login when signed out, preserving the intended
// destination so the user lands where they meant to after authenticating.
export default function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="db-boot">
        <span className="db-spinner" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  // Enforce email verification client-side to match the Flutter gate (auth_controller signs out
  // unverified accounts). The backend gate is off by default (REQUIRE_EMAIL_VERIFIED), so without
  // this an unverified session — a typed /app URL or the live post-register session — would get
  // full access. Bounce to /login, which holds unverified users and offers a resend; `from`
  // preserves their intended destination (incl. an invite /join code) for after they verify. (QA P1-4)
  // A managed child (parental controls) signs in via a custom token and has no email — so
  // `emailVerified` is false. Allow email-less accounts; password/OAuth users still need verifying.
  if (!user.emailVerified && user.email) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}
